const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid #8a6a00', fontFamily:"'Georgia', serif", color:'#1a1200', lineHeight:'1.7', background:'#fffdf0' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #d4a000', paddingBottom:'8px', marginBottom:'24px', color:'#7a4f00' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#b88000', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #d4a000', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#fffbe6', border:'2px solid #d4a000', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7a4f00', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #d4a000' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#b88000', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #f0d98a', verticalAlign:'top', background:'#fffbee' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #f0d98a', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#7a4f00', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#fffdf5', border:'1px solid #e8c84a', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#7a4f00', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#666', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Detail</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram: CAN Network Topology ────────────────────────────────────
function DiagramCANTopology() {
  const W = 900, H = 320;
  // Bus backbone runs horizontally across the middle
  const busY = 160;
  const busX1 = 60, busX2 = 840;

  const nodes = [
    { label:'ECU', sub:'Engine\nControl', x: 120 },
    { label:'ABS', sub:'Brake\nControl',  x: 270 },
    { label:'TCU', sub:'Transmission\nControl', x: 420 },
    { label:'BCM', sub:'Body\nControl',   x: 570 },
    { label:'ADAS', sub:'Driver\nAssist', x: 720 },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>CAN Bus Network Topology — Linear Bus with Termination Resistors</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrowCAN" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#d4a000"/>
          </marker>
        </defs>

        {/* Termination resistors */}
        {[busX1, busX2].map((x, i) => (
          <g key={i}>
            <rect x={x - (i===0?30:10)} y={busY-22} width={8} height={44} rx={2} fill="none" stroke="#b88000" strokeWidth="2.5"/>
            <text x={x - (i===0?22:2)} y={busY-28} fontSize="10" fill="#b88000" textAnchor="middle">120Ω</text>
            <line x1={x-(i===0?26:2)} y1={busY-22} x2={x-(i===0?26:2)} y2={busY-36} stroke="#b88000" strokeWidth="1.5"/>
            <line x1={x-(i===0?26:2)} y1={busY+22} x2={x-(i===0?26:2)} y2={busY+36} stroke="#b88000" strokeWidth="1.5"/>
          </g>
        ))}

        {/* CAN_H bus rail */}
        <line x1={busX1} y1={busY-10} x2={busX2} y2={busY-10} stroke="#d4a000" strokeWidth="4"/>
        <text x={busX1-8} y={busY-13} textAnchor="end" fontSize="11" fontWeight="700" fill="#d4a000">CAN_H</text>

        {/* CAN_L bus rail */}
        <line x1={busX1} y1={busY+10} x2={busX2} y2={busY+10} stroke="#b88000" strokeWidth="4"/>
        <text x={busX1-8} y={busY+16} textAnchor="end" fontSize="11" fontWeight="700" fill="#b88000">CAN_L</text>

        {/* Node stubs and boxes */}
        {nodes.map((n, i) => {
          const boxH = 70, boxW = 110, boxY = busY - 110;
          const lines = n.sub.split('\n');
          return (
            <g key={i}>
              {/* Stub lines from bus to node */}
              <line x1={n.x} y1={busY-10} x2={n.x} y2={boxY+boxH} stroke="#d4a000" strokeWidth="2"/>
              <line x1={n.x} y1={busY+10} x2={n.x} y2={boxY+boxH} stroke="#b88000" strokeWidth="2"/>
              {/* Node box */}
              <rect x={n.x-boxW/2} y={boxY} width={boxW} height={boxH} rx={7} fill="#d4a000"/>
              <text x={n.x} y={boxY+24} textAnchor="middle" fontSize="14" fontWeight="700" fill="#fff">{n.label}</text>
              {lines.map((l,li)=>(
                <text key={li} x={n.x} y={boxY+40+li*14} textAnchor="middle" fontSize="10" fill="#fff9cc">{l}</text>
              ))}
            </g>
          );
        })}

        {/* Gateway / diagnostic node below the bus */}
        <line x1={480} y1={busY+10} x2={480} y2={busY+70} stroke="#e07b00" strokeWidth="2"/>
        <rect x={420} y={busY+70} width={120} height={50} rx={6} fill="#e07b00"/>
        <text x={480} y={busY+91} textAnchor="middle" fontSize="12" fontWeight="700" fill="#fff">OBD-II</text>
        <text x={480} y={busY+108} textAnchor="middle" fontSize="10" fill="#fff9cc">Diagnostic Port</text>

        {/* Bidirectional arrows on bus */}
        <line x1={200} y1={busY-36} x2={340} y2={busY-36} stroke="#d4a000" strokeWidth="1.2"
          markerEnd="url(#arrowCAN)" strokeDasharray="4,3" opacity="0.6"/>
        <line x1={340} y1={busY-44} x2={200} y2={busY-44} stroke="#d4a000" strokeWidth="1.2"
          markerEnd="url(#arrowCAN)" strokeDasharray="4,3" opacity="0.6"/>
        <text x={270} y={busY-50} textAnchor="middle" fontSize="9" fill="#7a4f00" fontStyle="italic">broadcast both ways</text>

        {/* Labels */}
        <text x={W/2} y={H-8} textAnchor="middle" fontSize="10" fill="#888" fontStyle="italic">
          Any node can transmit; all other nodes receive simultaneously. No master required.
        </text>
      </svg>
      <div style={S.dCaption}>Linear bus topology: two wires (CAN_H, CAN_L) with 120 Ω termination resistors at each end</div>
    </div>
  );
}

// ── Diagram: Differential Signalling ─────────────────────────────────
function DiagramDifferential() {
  const W = 900, H = 240;
  const startX = 80, endX = 820;
  const domStart = 200, domEnd = 450;
  const dom2Start = 570, dom2End = 760;

  // Recessive: CAN_H=2.5V, CAN_L=2.5V → diff=0
  // Dominant:  CAN_H=3.5V, CAN_L=1.5V → diff=2V

  const scaleY = (v, min, max, top, bot) => top + (bot-top)*(1-(v-min)/(max-min));
  const Ytop = 20, Ybot = 100;
  const Vmin = 0, Vmax = 5;

  // CAN_H waveform points (recessive=2.5, dominant=3.5)
  const hPts = [
    [startX, scaleY(2.5,Vmin,Vmax,Ytop,Ybot)],
    [domStart, scaleY(2.5,Vmin,Vmax,Ytop,Ybot)],
    [domStart, scaleY(3.5,Vmin,Vmax,Ytop,Ybot)],
    [domEnd, scaleY(3.5,Vmin,Vmax,Ytop,Ybot)],
    [domEnd, scaleY(2.5,Vmin,Vmax,Ytop,Ybot)],
    [dom2Start, scaleY(2.5,Vmin,Vmax,Ytop,Ybot)],
    [dom2Start, scaleY(3.5,Vmin,Vmax,Ytop,Ybot)],
    [dom2End, scaleY(3.5,Vmin,Vmax,Ytop,Ybot)],
    [dom2End, scaleY(2.5,Vmin,Vmax,Ytop,Ybot)],
    [endX, scaleY(2.5,Vmin,Vmax,Ytop,Ybot)],
  ];

  // CAN_L waveform points (recessive=2.5, dominant=1.5)
  const lPts = [
    [startX, scaleY(2.5,Vmin,Vmax,Ytop,Ybot)],
    [domStart, scaleY(2.5,Vmin,Vmax,Ytop,Ybot)],
    [domStart, scaleY(1.5,Vmin,Vmax,Ytop,Ybot)],
    [domEnd, scaleY(1.5,Vmin,Vmax,Ytop,Ybot)],
    [domEnd, scaleY(2.5,Vmin,Vmax,Ytop,Ybot)],
    [dom2Start, scaleY(2.5,Vmin,Vmax,Ytop,Ybot)],
    [dom2Start, scaleY(1.5,Vmin,Vmax,Ytop,Ybot)],
    [dom2End, scaleY(1.5,Vmin,Vmax,Ytop,Ybot)],
    [dom2End, scaleY(2.5,Vmin,Vmax,Ytop,Ybot)],
    [endX, scaleY(2.5,Vmin,Vmax,Ytop,Ybot)],
  ];

  const toPath = pts => 'M ' + pts.map(p=>p.join(',')).join(' L ');

  // Differential (CAN_H - CAN_L): recessive=0, dominant=2
  const dYtop = 130, dYbot = 200;
  const dPts = [
    [startX, scaleY(0,0,3,dYtop,dYbot)],
    [domStart, scaleY(0,0,3,dYtop,dYbot)],
    [domStart, scaleY(2,0,3,dYtop,dYbot)],
    [domEnd, scaleY(2,0,3,dYtop,dYbot)],
    [domEnd, scaleY(0,0,3,dYtop,dYbot)],
    [dom2Start, scaleY(0,0,3,dYtop,dYbot)],
    [dom2Start, scaleY(2,0,3,dYtop,dYbot)],
    [dom2End, scaleY(2,0,3,dYtop,dYbot)],
    [dom2End, scaleY(0,0,3,dYtop,dYbot)],
    [endX, scaleY(0,0,3,dYtop,dYbot)],
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>CAN Differential Signalling — CAN_H, CAN_L, and Differential Voltage</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {/* Y axis labels - top panel */}
        <text x={10} y={Ytop+4} fontSize="9" fill="#888">5V</text>
        <text x={10} y={scaleY(3.5,0,5,Ytop,Ybot)+4} fontSize="9" fill="#d4a000">3.5V</text>
        <text x={10} y={scaleY(2.5,0,5,Ytop,Ybot)+4} fontSize="9" fill="#888">2.5V</text>
        <text x={10} y={scaleY(1.5,0,5,Ytop,Ybot)+4} fontSize="9" fill="#b88000">1.5V</text>
        <text x={10} y={Ybot+4} fontSize="9" fill="#888">0V</text>

        {/* Grid lines */}
        {[2.5,3.5,1.5].map((v,i) => (
          <line key={i} x1={startX} y1={scaleY(v,0,5,Ytop,Ybot)} x2={endX} y2={scaleY(v,0,5,Ytop,Ybot)}
            stroke="#e8c84a" strokeWidth="0.5" strokeDasharray="3,3"/>
        ))}

        {/* CAN_H */}
        <path d={toPath(hPts)} fill="none" stroke="#d4a000" strokeWidth="2.5"/>
        <text x={endX+4} y={scaleY(3.5,0,5,Ytop,Ybot)+4} fontSize="11" fontWeight="700" fill="#d4a000">CAN_H</text>

        {/* CAN_L */}
        <path d={toPath(lPts)} fill="none" stroke="#b88000" strokeWidth="2.5"/>
        <text x={endX+4} y={scaleY(1.5,0,5,Ytop,Ybot)+4} fontSize="11" fontWeight="700" fill="#b88000">CAN_L</text>

        {/* Dominant shading */}
        {[[domStart,domEnd],[dom2Start,dom2End]].map(([x1,x2],i)=>(
          <rect key={i} x={x1} y={Ytop} width={x2-x1} height={Ybot-Ytop} fill="#d4a000" opacity="0.08"/>
        ))}

        {/* Dominant / Recessive labels */}
        {[[domStart,domEnd,'DOMINANT\n(logic 0)'],[startX,domStart,'RECESSIVE\n(logic 1)']].map(([x1,x2,lbl],i)=>(
          lbl.split('\n').map((l,li)=>(
            <text key={`${i}-${li}`} x={(x1+x2)/2} y={Ybot+16+li*13}
              textAnchor="middle" fontSize="10" fontWeight={i===0?"700":"400"}
              fill={i===0?"#7a4f00":"#aaa"}>{l}</text>
          ))
        ))}

        {/* Separator line */}
        <line x1={startX} y1={dYtop-8} x2={endX} y2={dYtop-8} stroke="#e8c84a" strokeWidth="0.8" strokeDasharray="4,4"/>
        <text x={endX+4} y={dYtop-4} fontSize="9" fill="#888">DIFF</text>

        {/* Differential voltage panel */}
        <text x={10} y={dYtop+4} fontSize="9" fill="#888">2V</text>
        <text x={10} y={scaleY(0,0,3,dYtop,dYbot)+4} fontSize="9" fill="#888">0V</text>
        <path d={toPath(dPts)} fill="none" stroke="#e07b00" strokeWidth="2.5"/>
        <text x={endX+4} y={dYtop+10} fontSize="11" fontWeight="700" fill="#e07b00">V_diff</text>
        <text x={endX+4} y={dYtop+22} fontSize="9" fill="#e07b00">H−L</text>

        {/* Dominant shading on diff panel */}
        {[[domStart,domEnd],[dom2Start,dom2End]].map(([x1,x2],i)=>(
          <rect key={i} x={x1} y={dYtop} width={x2-x1} height={dYbot-dYtop} fill="#e07b00" opacity="0.12"/>
        ))}

        {/* Noise immunity annotation */}
        <line x1={340} y1={40} x2={340} y2={80} stroke="#7a4f00" strokeWidth="0.8" strokeDasharray="2,2"/>
        <text x={342} y={52} fontSize="9" fill="#7a4f00">V_diff = 2V</text>
        <text x={342} y={64} fontSize="9" fill="#7a4f00">(dominant)</text>
      </svg>
      <div style={S.dCaption}>Noise on both wires cancels out: V_diff = CAN_H − CAN_L. Dominant (0) wins over Recessive (1) — wired-AND logic.</div>
    </div>
  );
}

// ── Diagram: Standard CAN Frame (11-bit ID) ──────────────────────────
function DiagramCANFrame() {
  const W = 900, H = 210;

  const fields = [
    { label:'SOF',   sub:'1 bit',   color:'#d4a000', w:36 },
    { label:'ID',    sub:'11 bits', color:'#c49000', w:90 },
    { label:'RTR',   sub:'1 bit',   color:'#b88000', w:36 },
    { label:'IDE',   sub:'1 bit',   color:'#c49000', w:36 },
    { label:'r0',    sub:'1 bit',   color:'#b88000', w:30 },
    { label:'DLC',   sub:'4 bits',  color:'#c49000', w:50 },
    { label:'DATA',  sub:'0–64 bytes', color:'#d4a000', w:130 },
    { label:'CRC',   sub:'15 bits', color:'#e07b00', w:70 },
    { label:'CRC\nDel', sub:'1 bit', color:'#b88000', w:36 },
    { label:'ACK',   sub:'1 bit',   color:'#e07b00', w:36 },
    { label:'ACK\nDel', sub:'1 bit', color:'#b88000', w:36 },
    { label:'EOF',   sub:'7 bits',  color:'#c49000', w:50 },
    { label:'IFS',   sub:'3 bits',  color:'#b88000', w:40 },
  ];

  let cx = 0;
  const rects = fields.map(f => { const x = cx; cx += f.w + 3; return {...f, x}; });
  const totalW = cx;
  const scale = (W - 10) / totalW;
  const Y = 55, H2 = 80;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>CAN 2.0A Standard Frame Structure (11-bit Identifier)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {rects.map((r, i) => {
          const rx = 5 + r.x * scale;
          const rw = r.w * scale;
          const lines = r.label.split('\n');
          return (
            <g key={i}>
              <rect x={rx} y={Y} width={rw} height={H2} rx={3} fill={r.color} opacity="0.88"/>
              {lines.map((l,li)=>(
                <text key={li} x={rx+rw/2} y={Y+H2/2-6+(li-lines.length/2+0.5)*14}
                  textAnchor="middle" fontSize={rw>50?11:9} fontWeight="700" fill="#fff"
                  fontFamily="'Georgia',serif">{l}</text>
              ))}
              <text x={rx+rw/2} y={Y+H2-8} textAnchor="middle" fontSize="9"
                fill="#fff9cc" fontFamily="'Courier New',monospace">{r.sub}</text>
              <line x1={rx} y1={Y-4} x2={rx} y2={Y+H2+4} stroke="#fff" strokeWidth="0.5" opacity="0.4"/>
            </g>
          );
        })}

        {/* Group brackets */}
        {[
          { label:'Arbitration Field', x1: 5+(rects[0].x)*scale, x2: 5+(rects[2].x+rects[2].w)*scale, color:'#d4a000' },
          { label:'Control Field', x1: 5+(rects[3].x)*scale, x2: 5+(rects[5].x+rects[5].w)*scale, color:'#c49000' },
          { label:'Data Field', x1: 5+(rects[6].x)*scale, x2: 5+(rects[6].x+rects[6].w)*scale, color:'#d4a000' },
          { label:'CRC Field', x1: 5+(rects[7].x)*scale, x2: 5+(rects[8].x+rects[8].w)*scale, color:'#e07b00' },
          { label:'ACK Field', x1: 5+(rects[9].x)*scale, x2: 5+(rects[10].x+rects[10].w)*scale, color:'#e07b00' },
        ].map((b,i)=>(
          <g key={i}>
            <line x1={b.x1} y1={Y+H2+8} x2={b.x2} y2={Y+H2+8} stroke={b.color} strokeWidth="1.5"/>
            <line x1={b.x1} y1={Y+H2+4} x2={b.x1} y2={Y+H2+12} stroke={b.color} strokeWidth="1.5"/>
            <line x1={b.x2} y1={Y+H2+4} x2={b.x2} y2={Y+H2+12} stroke={b.color} strokeWidth="1.5"/>
            <text x={(b.x1+b.x2)/2} y={Y+H2+26} textAnchor="middle" fontSize="9" fill={b.color}>{b.label}</text>
          </g>
        ))}

        {/* SOF annotation */}
        <text x={5+rects[0].x*scale+rects[0].w*scale/2} y={Y-10} textAnchor="middle"
          fontSize="9" fill="#7a4f00" fontStyle="italic">dominant</text>

        {/* Legend */}
        <rect x={5} y={4} width={260} height={38} rx={3} fill="#fffbe6" stroke="#d4a000"/>
        <text x={12} y={18} fontSize="9" fontWeight="700" fill="#7a4f00">SOF=Start of Frame  RTR=Remote Transmission Request</text>
        <text x={12} y={32} fontSize="9" fill="#7a4f00">IDE=ID Extension  DLC=Data Length Code  EOF=End of Frame  IFS=Interframe Space</text>
      </svg>
      <div style={S.dCaption}>Total overhead: ~47 bits minimum per frame. At 500 kbps with 8-byte payload: ~160 µs/frame (~6,000 frames/sec)</div>
    </div>
  );
}

// ── Diagram: Extended Frame (29-bit ID) ──────────────────────────────
function DiagramExtendedFrame() {
  const W = 900, H = 185;

  const fields = [
    { label:'SOF',    sub:'1b',     color:'#d4a000', w:28 },
    { label:'ID A',   sub:'11 bits',color:'#c49000', w:80 },
    { label:'SRR',    sub:'1b',     color:'#b88000', w:28 },
    { label:'IDE=1',  sub:'1b',     color:'#e07b00', w:44 },
    { label:'ID B',   sub:'18 bits',color:'#c49000', w:100 },
    { label:'RTR',    sub:'1b',     color:'#b88000', w:28 },
    { label:'r1 r0',  sub:'2b',     color:'#c49000', w:36 },
    { label:'DLC',    sub:'4b',     color:'#b88000', w:40 },
    { label:'DATA',   sub:'0–8B',   color:'#d4a000', w:110 },
    { label:'CRC',    sub:'15b+del',color:'#e07b00', w:70 },
    { label:'ACK',    sub:'2b',     color:'#b88000', w:36 },
    { label:'EOF+IFS',sub:'10b',    color:'#c49000', w:60 },
  ];

  let cx = 0;
  const rects = fields.map(f => { const x = cx; cx += f.w + 3; return {...f, x}; });
  const totalW = cx;
  const scale = (W - 10) / totalW;
  const Y = 40, H2 = 80;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>CAN 2.0B Extended Frame Structure (29-bit Identifier = 11-bit ID_A + 18-bit ID_B)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {rects.map((r, i) => {
          const rx = 5 + r.x * scale;
          const rw = r.w * scale;
          return (
            <g key={i}>
              <rect x={rx} y={Y} width={rw} height={H2} rx={3} fill={r.color} opacity="0.88"/>
              <text x={rx+rw/2} y={Y+H2/2} textAnchor="middle" fontSize={rw>50?10:9}
                fontWeight="700" fill="#fff" fontFamily="'Georgia',serif">{r.label}</text>
              <text x={rx+rw/2} y={Y+H2-10} textAnchor="middle" fontSize="8"
                fill="#fff9cc" fontFamily="'Courier New',monospace">{r.sub}</text>
              <line x1={rx} y1={Y-3} x2={rx} y2={Y+H2+3} stroke="#fff" strokeWidth="0.5" opacity="0.4"/>
            </g>
          );
        })}

        {/* IDE=1 highlight annotation */}
        <line x1={5+(rects[3].x+rects[3].w/2)*scale} y1={Y}
          x2={5+(rects[3].x+rects[3].w/2)*scale} y2={Y-14} stroke="#e07b00" strokeWidth="1.5"/>
        <text x={5+(rects[3].x+rects[3].w/2)*scale} y={Y-16}
          textAnchor="middle" fontSize="9" fill="#e07b00">IDE=1 signals extended</text>

        {/* ID span bracket */}
        <line x1={5+rects[1].x*scale} y1={Y+H2+8} x2={5+(rects[4].x+rects[4].w)*scale} y2={Y+H2+8} stroke="#c49000" strokeWidth="1.5"/>
        <line x1={5+rects[1].x*scale} y1={Y+H2+4} x2={5+rects[1].x*scale} y2={Y+H2+12} stroke="#c49000" strokeWidth="1.5"/>
        <line x1={5+(rects[4].x+rects[4].w)*scale} y1={Y+H2+4} x2={5+(rects[4].x+rects[4].w)*scale} y2={Y+H2+12} stroke="#c49000" strokeWidth="1.5"/>
        <text x={(5+rects[1].x*scale+5+(rects[4].x+rects[4].w)*scale)/2} y={Y+H2+24}
          textAnchor="middle" fontSize="9" fill="#c49000">29-bit Identifier (2²⁹ = 536,870,912 unique IDs)</text>
      </svg>
      <div style={S.dCaption}>Extended frames are backwards compatible with standard frames — both can coexist on the same bus</div>
    </div>
  );
}

// ── Diagram: Arbitration / Bus Access ────────────────────────────────
function DiagramArbitration() {
  const W = 900, H = 280;

  // Show two nodes transmitting simultaneously, one losing arbitration
  // Node A wants to send ID 0b00110... (lower priority - sends 1 on bit 3)
  // Node B wants to send ID 0b00100... (higher priority - sends 0 on bit 3)

  const bits = ['SOF','b10','b9','b8','b7 — Node A loses arbitration','b6','b5'];
  const nodeABits = [0, 0, 0, 1, 1, 0, 1]; // sends recessive (1) on bit 7
  const nodeBBits = [0, 0, 0, 1, 0, 0, 0]; // sends dominant (0) on bit 7
  const busBits   = [0, 0, 0, 1, 0, 0, 0]; // bus = wired-AND, dominant wins

  const bitW = 100, startX = 60;
  const aY = 30, bY = 100, busY = 180;
  const H2 = 28;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>CAN Bus Arbitration — Non-Destructive, Bit-by-Bit (Wired-AND)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrowArb" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#e07b00"/>
          </marker>
        </defs>

        {/* Row labels */}
        <text x={4} y={aY+H2/2+5} fontSize="11" fontWeight="700" fill="#d4a000">Node A</text>
        <text x={4} y={aY+H2/2+19} fontSize="9" fill="#d4a000">ID=0x062</text>
        <text x={4} y={bY+H2/2+5} fontSize="11" fontWeight="700" fill="#b88000">Node B</text>
        <text x={4} y={bY+H2/2+19} fontSize="9" fill="#b88000">ID=0x04B</text>
        <text x={4} y={busY+H2/2+5} fontSize="11" fontWeight="700" fill="#7a4f00">Bus</text>
        <text x={4} y={busY+H2/2+19} fontSize="9" fill="#7a4f00">(wired-AND)</text>

        {bits.map((label, i) => {
          const x = startX + i * bitW;
          const aVal = nodeABits[i], bVal = nodeBBits[i], busVal = busBits[i];
          const losesBit = i === 4;
          const aFill = aVal===0?'#d4a000':'#fffbe6';
          const bFill = bVal===0?'#b88000':'#fffbe6';
          const busFill = busVal===0?'#7a4f00':'#fffbe6';

          return (
            <g key={i}>
              {/* Bit column background for lose point */}
              {losesBit && <rect x={x-2} y={aY-10} width={bitW-6} height={busY+H2+30-aY+10}
                fill="#e07b00" opacity="0.08" rx={3}/>}

              {/* Node A bit */}
              <rect x={x} y={aY} width={bitW-8} height={H2} rx={3}
                fill={aFill} stroke="#d4a000" strokeWidth="1.5"/>
              <text x={x+(bitW-8)/2} y={aY+H2/2+5} textAnchor="middle" fontSize="14"
                fontWeight="700" fill={aVal===0?'#fff':'#d4a000'}>{aVal===0?'DOM':'REC'}</text>

              {/* Node B bit */}
              <rect x={x} y={bY} width={bitW-8} height={H2} rx={3}
                fill={bFill} stroke="#b88000" strokeWidth="1.5"/>
              <text x={x+(bitW-8)/2} y={bY+H2/2+5} textAnchor="middle" fontSize="14"
                fontWeight="700" fill={bVal===0?'#fff':'#b88000'}>{bVal===0?'DOM':'REC'}</text>

              {/* Bus bit */}
              <rect x={x} y={busY} width={bitW-8} height={H2} rx={3}
                fill={busFill} stroke="#7a4f00" strokeWidth="1.5"/>
              <text x={x+(bitW-8)/2} y={busY+H2/2+5} textAnchor="middle" fontSize="14"
                fontWeight="700" fill={busVal===0?'#fff':'#7a4f00'}>{busVal===0?'DOM':'REC'}</text>

              {/* Bit label */}
              <text x={x+(bitW-8)/2} y={aY-14} textAnchor="middle" fontSize={losesBit?9:9}
                fill={losesBit?'#e07b00':'#888'} fontWeight={losesBit?'700':'400'}>{label}</text>
            </g>
          );
        })}

        {/* Arrow showing Node A detects mismatch and backs off */}
        <line x1={startX + 4*bitW + 46} y1={aY+H2/2}
          x2={startX + 4*bitW + 46} y2={bY-14} stroke="#e07b00" strokeWidth="2" markerEnd="url(#arrowArb)"/>
        <text x={startX + 4*bitW + 52} y={aY+H2*1.5+4} fontSize="9" fill="#e07b00" fontWeight="700">Node A reads</text>
        <text x={startX + 4*bitW + 52} y={aY+H2*1.5+16} fontSize="9" fill="#e07b00" fontWeight="700">DOM ≠ its REC</text>
        <text x={startX + 4*bitW + 52} y={aY+H2*1.5+28} fontSize="9" fill="#e07b00">→ backs off,</text>
        <text x={startX + 4*bitW + 52} y={aY+H2*1.5+40} fontSize="9" fill="#e07b00">waits to retry</text>

        {/* Node B continues */}
        <text x={startX + 5*bitW + 20} y={busY+H2+20} fontSize="9" fill="#b88000" fontWeight="700">Node B wins, continues transmitting</text>

        {/* Priority rule callout */}
        <rect x={5} y={H-34} width={W-10} height={26} rx={3} fill="#fffbe6" stroke="#d4a000"/>
        <text x={14} y={H-18} fontSize="10" fill="#7a4f00" fontWeight="700">Priority Rule:</text>
        <text x={90} y={H-18} fontSize="10" fill="#333">Lower numeric ID = higher priority. Dominant bit (0) always wins over recessive bit (1) on the shared bus.</text>
        <text x={14} y={H-6} fontSize="10" fill="#333">Losing node does NOT corrupt the winning node's message — it simply stops driving and waits.</text>
      </svg>
      <div style={S.dCaption}>Arbitration is lossless — the winning message is transmitted without any re-transmission or delay</div>
    </div>
  );
}

// ── Diagram: Bit Timing ───────────────────────────────────────────────
function DiagramBitTiming() {
  const W = 900, H = 200;
  const startX = 60;
  const segments = [
    { label:'Sync\nSeg', bits:1, color:'#d4a000' },
    { label:'Prop\nSeg', bits:3, color:'#c49000' },
    { label:'Phase\nSeg 1', bits:4, color:'#b88000' },
    { label:'Phase\nSeg 2', bits:3, color:'#e07b00' },
  ];
  const totalBits = segments.reduce((s,g)=>s+g.bits,0);
  const unitW = (W - startX - 40) / totalBits;
  const Y = 60, H2 = 70;

  let cx = startX;
  const rects = segments.map(seg => {
    const x = cx; cx += seg.bits * unitW;
    return { ...seg, x, w: seg.bits * unitW };
  });

  const samplePoint = rects[2].x + rects[2].w;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>CAN Bit Timing — One Bit Period = Sync + Prop + Phase1 + Phase2</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrowBit" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#d4a000"/>
          </marker>
          <marker id="arrowBitR" markerWidth="7" markerHeight="7" refX="2" refY="3.5" orient="auto-start-reverse">
            <polygon points="0 0,6 3.5,0 7" fill="#d4a000"/>
          </marker>
        </defs>

        {/* Segments */}
        {rects.map((r, i) => {
          const lines = r.label.split('\n');
          return (
            <g key={i}>
              <rect x={r.x} y={Y} width={r.w-2} height={H2} rx={3} fill={r.color} opacity="0.88"/>
              {lines.map((l,li)=>(
                <text key={li} x={r.x+r.w/2} y={Y+H2/2-8+li*16}
                  textAnchor="middle" fontSize="11" fontWeight="700" fill="#fff">{l}</text>
              ))}
              <text x={r.x+r.w/2} y={Y+H2-10} textAnchor="middle" fontSize="9"
                fill="#fff9cc">{r.bits} TQ</text>
            </g>
          );
        })}

        {/* Sample point marker */}
        <line x1={samplePoint} y1={Y-18} x2={samplePoint} y2={Y+H2+28} stroke="#e07b00" strokeWidth="2" strokeDasharray="4,2"/>
        <text x={samplePoint+4} y={Y-8} fontSize="10" fontWeight="700" fill="#e07b00">Sample Point</text>
        <text x={samplePoint+4} y={Y+H2+16} fontSize="9" fill="#e07b00">bit value read here</text>

        {/* Total bit period arrow */}
        <line x1={startX} y1={Y+H2+30} x2={startX + totalBits*unitW} y2={Y+H2+30}
          stroke="#d4a000" strokeWidth="1.5" markerEnd="url(#arrowBit)" markerStart="url(#arrowBitR)"/>
        <text x={startX + totalBits*unitW/2} y={Y+H2+46} textAnchor="middle"
          fontSize="11" fontWeight="700" fill="#7a4f00">1 Bit Period = 11 TQ (Time Quanta)</text>

        {/* TQ label */}
        <text x={startX + unitW/2} y={Y-20} textAnchor="middle" fontSize="9" fill="#888">1 TQ</text>
        <line x1={startX} y1={Y-14} x2={startX+unitW-2} y2={Y-14} stroke="#888" strokeWidth="1"/>
        <line x1={startX} y1={Y-18} x2={startX} y2={Y-10} stroke="#888" strokeWidth="1"/>
        <line x1={startX+unitW-2} y1={Y-18} x2={startX+unitW-2} y2={Y-10} stroke="#888" strokeWidth="1"/>

        {/* Notes */}
        <rect x={5} y={4} width={460} height={46} rx={3} fill="#fffbe6" stroke="#d4a000"/>
        <text x={12} y={18} fontSize="9" fontWeight="700" fill="#7a4f00">TQ = Time Quantum = 1 / (oscillator_freq / prescaler)</text>
        <text x={12} y={31} fontSize="9" fill="#333">SJW (Sync Jump Width): controller can shorten/lengthen Phase Seg1 or Seg2 by up to SJW TQs</text>
        <text x={12} y={44} fontSize="9" fill="#333">to resynchronise on edge transitions and compensate for crystal oscillator drift between nodes.</text>
      </svg>
      <div style={S.dCaption}>Example: 500 kbps with 48 MHz clock, prescaler=6 → TQ=125ns. 11 TQ × 125ns = 1.375µs ≈ 727 kbps (adjust prescaler/TQ count)</div>
    </div>
  );
}

// ── Diagram: Error Frames ─────────────────────────────────────────────
function DiagramErrorFrame() {
  const W = 900, H = 200;

  const sections = [
    { label:'Normal\nData Frame', w:160, color:'#c49000', y:40 },
    { label:'Error\nFlag', sub:'6 dom bits\n(active error)', w:90, color:'#e05000', y:40 },
    { label:'Error\nDelimiter', sub:'8 rec bits', w:90, color:'#b88000', y:40 },
    { label:'IFS', sub:'3 bits', w:50, color:'#c49000', y:40 },
    { label:'Retransmit\n(if TEC < 256)', w:120, color:'#d4a000', y:40 },
  ];

  let cx = 10;
  const rects = sections.map(s => { const x=cx; cx+=s.w+8; return {...s,x}; });
  const H2 = 70;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>CAN Error Frame — Active Error Flag Destroys the Current Frame</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {rects.map((r,i)=>{
          const lines = r.label.split('\n');
          const subLines = r.sub ? r.sub.split('\n') : [];
          return (
            <g key={i}>
              <rect x={r.x} y={r.y} width={r.w} height={H2} rx={5}
                fill={r.color} opacity={i===1?1:0.88}/>
              {lines.map((l,li)=>(
                <text key={li} x={r.x+r.w/2} y={r.y+22+li*16} textAnchor="middle"
                  fontSize="11" fontWeight="700" fill="#fff">{l}</text>
              ))}
              {subLines.map((l,li)=>(
                <text key={li} x={r.x+r.w/2} y={r.y+H2-22+li*12} textAnchor="middle"
                  fontSize="9" fill="#fff9cc" fontFamily="'Courier New',monospace">{l}</text>
              ))}
              {i < rects.length-1 && (
                <line x1={r.x+r.w+4} y1={r.y+H2/2} x2={r.x+r.w+8} y2={r.y+H2/2}
                  stroke="#d4a000" strokeWidth="2"/>
              )}
            </g>
          );
        })}

        {/* Error flag violates bit-stuffing rule → all nodes detect error */}
        <line x1={rects[1].x+rects[1].w/2} y1={rects[1].y+H2} x2={rects[1].x+rects[1].w/2} y2={H-30}
          stroke="#e05000" strokeWidth="1.5" strokeDasharray="3,2"/>
        <text x={rects[1].x+rects[1].w/2} y={H-18} textAnchor="middle" fontSize="9" fill="#e05000">
          6 consecutive dominant bits violates bit-stuffing → all nodes detect error simultaneously
        </text>

        {/* TEC/REC counters */}
        <rect x={W-240} y={40} width={230} height={70} rx={4} fill="#fffbe6" stroke="#d4a000"/>
        <text x={W-125} y={58} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7a4f00">Error Counters</text>
        <text x={W-230} y={74} fontSize="9" fill="#333">TEC (Transmit Error Counter): +8 per error, −1 per OK frame</text>
        <text x={W-230} y={88} fontSize="9" fill="#333">REC (Receive Error Counter):  +1 per error, −1 per OK frame</text>
        <text x={W-230} y={102} fontSize="9" fill="#e05000">TEC/REC &gt; 127 → Error Passive;  TEC &gt; 255 → Bus Off</text>
      </svg>
      <div style={S.dCaption}>A faulty node automatically isolates itself (Bus Off state) after 256 transmit errors — protecting the rest of the network</div>
    </div>
  );
}

// ── Diagram: CAN FD vs Classical CAN ─────────────────────────────────
function DiagramCANFD() {
  const W = 900, H = 240;

  // Show two frames side by side: classical vs CAN FD
  const classX = 20, fdX = 480;
  const colW = 400, Y = 50, H2 = 80;

  const classFields = [
    { label:'Arb.', w:60, color:'#c49000' },
    { label:'Ctrl', w:40, color:'#b88000' },
    { label:'DATA\n8 bytes max', w:120, color:'#d4a000' },
    { label:'CRC', w:50, color:'#e07b00' },
    { label:'ACK\nEOF', w:60, color:'#b88000' },
  ];

  const fdFields = [
    { label:'Arb.', w:60, color:'#c49000' },
    { label:'Ctrl\n+FDF+BRS', w:55, color:'#e07b00' },
    { label:'DATA\n64 bytes max', w:140, color:'#d4a000' },
    { label:'CRC\n21-bit', w:55, color:'#e07b00' },
    { label:'ACK\nEOF', w:50, color:'#b88000' },
  ];

  const buildRects = (fields, startX, colW) => {
    const total = fields.reduce((s,f)=>s+f.w,0)+fields.length*3;
    const scale = (colW-10)/total;
    let cx = startX+5;
    return fields.map(f => { const x=cx; cx+=f.w*scale+3; return {...f,x,w:f.w*scale}; });
  };

  const cRects = buildRects(classFields, classX, colW);
  const fRects = buildRects(fdFields, fdX, colW);

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Classical CAN vs CAN FD (Flexible Data-rate) — Frame Comparison</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Labels */}
        <text x={classX+colW/2} y={Y-14} textAnchor="middle" fontSize="13" fontWeight="700" fill="#7a4f00">Classical CAN 2.0</text>
        <text x={fdX+colW/2} y={Y-14} textAnchor="middle" fontSize="13" fontWeight="700" fill="#7a4f00">CAN FD (ISO 11898-1:2015)</text>

        {/* Divider */}
        <line x1={W/2} y1={20} x2={W/2} y2={H-20} stroke="#e8c84a" strokeWidth="1.5" strokeDasharray="5,3"/>

        {cRects.map((r,i)=>{
          const lines=r.label.split('\n');
          return (
            <g key={i}>
              <rect x={r.x} y={Y} width={r.w} height={H2} rx={3} fill={r.color} opacity="0.88"/>
              {lines.map((l,li)=>(<text key={li} x={r.x+r.w/2} y={Y+H2/2-6+li*16}
                textAnchor="middle" fontSize="10" fontWeight="700" fill="#fff">{l}</text>))}
            </g>
          );
        })}

        {fRects.map((r,i)=>{
          const lines=r.label.split('\n');
          return (
            <g key={i}>
              <rect x={r.x} y={Y} width={r.w} height={H2} rx={3} fill={r.color} opacity="0.88"/>
              {lines.map((l,li)=>(<text key={li} x={r.x+r.w/2} y={Y+H2/2-6+li*16}
                textAnchor="middle" fontSize="10" fontWeight="700" fill="#fff">{l}</text>))}
            </g>
          );
        })}

        {/* Speed annotation */}
        <rect x={classX} y={Y+H2+12} width={colW-10} height={28} rx={3} fill="#fffbe6" stroke="#c49000"/>
        <text x={classX+colW/2-5} y={Y+H2+24} textAnchor="middle" fontSize="10" fill="#7a4f00" fontWeight="700">Nominal bit rate: up to 1 Mbit/s</text>
        <text x={classX+colW/2-5} y={Y+H2+38} textAnchor="middle" fontSize="9" fill="#888">Data phase: same rate (no switching)</text>

        <rect x={fdX} y={Y+H2+12} width={colW-10} height={28} rx={3} fill="#fffbe6" stroke="#e07b00"/>
        <text x={fdX+colW/2} y={Y+H2+24} textAnchor="middle" fontSize="10" fill="#7a4f00" fontWeight="700">Nominal: 1 Mbit/s — Data phase: up to 8+ Mbit/s</text>
        <text x={fdX+colW/2} y={Y+H2+38} textAnchor="middle" fontSize="9" fill="#e07b00">BRS bit switches to faster rate for data payload only</text>

        {/* Key difference callouts */}
        <text x={W/2+10} y={H-28} fontSize="9" fill="#e07b00" fontWeight="700">FDF=1: CAN FD frame</text>
        <text x={W/2+10} y={H-16} fontSize="9" fill="#e07b00">BRS=1: switch to data bit rate</text>
        <text x={W/2+10} y={H-4} fontSize="9" fill="#e07b00">ESI: error state indicator</text>

        <text x={classX+10} y={H-10} fontSize="9" fill="#7a4f00">Max efficiency: 8B data / ~111 bits overhead ≈ 58%</text>
        <text x={fdX+10} y={H-10} fontSize="9" fill="#7a4f00">Max efficiency: 64B data / ~130 bits overhead ≈ 80%</text>
      </svg>
      <div style={S.dCaption}>CAN FD is backwards compatible during arbitration phase; the data phase switches speed — transceivers must support FD</div>
    </div>
  );
}

// ── Diagram: Error States ─────────────────────────────────────────────
function DiagramErrorStates() {
  const W = 900, H = 370;

  // Circle positions: well separated horizontally, sitting in upper portion
  const r = 60;
  const cy = 90; // circle centres Y
  const states = [
    { label:'Error\nActive',  sub:['TEC ≤ 127', '& REC ≤ 127'], cx:150,  cy, color:'#d4a000' },
    { label:'Error\nPassive', sub:['TEC > 127',  'or REC > 127'], cx:450, cy, color:'#e07b00' },
    { label:'Bus\nOff',       sub:['TEC > 255'],                  cx:750, cy, color:'#a03000' },
  ];

  // Forward arrows (above circle centres)
  const arrowY_fwd = cy - r - 14;   // above circles
  const arrowY_rev = cy - r - 2;    // just below forward arrows

  // Recovery arc drops well below circles, above the info boxes
  const arcDropY = cy + r + 50;     // 50px below circle bottom

  // Info boxes sit below the arc
  const boxY = arcDropY + 36;
  const boxW = 240, boxH = 68;
  const boxXs = [20, (W - boxW) / 2, W - boxW - 20];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>CAN Node Error State Machine</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrowStateFwd" markerWidth="8" markerHeight="7" refX="7" refY="3.5" orient="auto">
            <polygon points="0 0,7 3.5,0 7" fill="#7a4f00"/>
          </marker>
          <marker id="arrowStateRev" markerWidth="8" markerHeight="7" refX="7" refY="3.5" orient="auto">
            <polygon points="0 0,7 3.5,0 7" fill="#d4a000"/>
          </marker>
          <marker id="arrowStateBusOff" markerWidth="8" markerHeight="7" refX="7" refY="3.5" orient="auto">
            <polygon points="0 0,7 3.5,0 7" fill="#a03000"/>
          </marker>
          <marker id="arrowStateRec" markerWidth="8" markerHeight="7" refX="7" refY="3.5" orient="auto">
            <polygon points="0 0,7 3.5,0 7" fill="#d4a000"/>
          </marker>
        </defs>

        {/* ── Circles ── */}
        {states.map((s, i) => (
          <g key={i}>
            <circle cx={s.cx} cy={s.cy} r={r} fill={s.color} opacity="0.92"/>
            {s.label.split('\n').map((l, li) => (
              <text key={li} x={s.cx} y={s.cy - 6 + li * 18}
                textAnchor="middle" fontSize="15" fontWeight="700" fill="#fff">{l}</text>
            ))}
            {s.sub.map((l, li) => (
              <text key={li} x={s.cx} y={s.cy + 32 + li * 13}
                textAnchor="middle" fontSize="9" fill="#fff9cc">{l}</text>
            ))}
          </g>
        ))}

        {/* ── Active → Passive (forward, above) ── */}
        <line
          x1={states[0].cx + r} y1={arrowY_fwd}
          x2={states[1].cx - r} y2={arrowY_fwd}
          stroke="#7a4f00" strokeWidth="2" markerEnd="url(#arrowStateFwd)"/>
        <text x={(states[0].cx + states[1].cx) / 2} y={arrowY_fwd - 5}
          textAnchor="middle" fontSize="10" fill="#7a4f00">TEC or REC &gt; 127</text>

        {/* ── Passive → Active (return, slightly lower) ── */}
        <line
          x1={states[1].cx - r} y1={arrowY_rev}
          x2={states[0].cx + r} y2={arrowY_rev}
          stroke="#d4a000" strokeWidth="2" markerEnd="url(#arrowStateRev)"/>
        <text x={(states[0].cx + states[1].cx) / 2} y={arrowY_rev + 13}
          textAnchor="middle" fontSize="10" fill="#d4a000">TEC ≤ 127 &amp; REC ≤ 127</text>

        {/* ── Passive → Bus Off ── */}
        <line
          x1={states[1].cx + r} y1={arrowY_fwd}
          x2={states[2].cx - r} y2={arrowY_fwd}
          stroke="#a03000" strokeWidth="2" markerEnd="url(#arrowStateBusOff)"/>
        <text x={(states[1].cx + states[2].cx) / 2} y={arrowY_fwd - 5}
          textAnchor="middle" fontSize="10" fill="#a03000">TEC &gt; 255</text>

        {/* ── Bus Off → Error Active (recovery arc, looping below) ── */}
        <path
          d={`M ${states[2].cx},${states[2].cy + r} C ${states[2].cx},${arcDropY + 18} ${states[0].cx},${arcDropY + 18} ${states[0].cx},${states[0].cy + r}`}
          fill="none" stroke="#d4a000" strokeWidth="1.8" strokeDasharray="6,3"
          markerEnd="url(#arrowStateRec)"/>
        {/* Recovery label sits on the arc curve */}
        <text x={W / 2} y={arcDropY + 12} textAnchor="middle" fontSize="9" fill="#d4a000">
          128 × 11 recessive bits (power cycle / controller reset) → back to Error Active
        </text>

        {/* ── Info boxes ── evenly spaced, below the arc ── */}
        {/* Error Active box */}
        <rect x={boxXs[0]} y={boxY} width={boxW} height={boxH} rx={5} fill="#fffbe6" stroke="#d4a000" strokeWidth="1.5"/>
        <text x={boxXs[0]+10} y={boxY+18} fontSize="10" fontWeight="700" fill="#7a4f00">Error Active:</text>
        <text x={boxXs[0]+10} y={boxY+34} fontSize="9" fill="#333">Can transmit &amp; receive normally</text>
        <text x={boxXs[0]+10} y={boxY+48} fontSize="9" fill="#333">Sends active error flags</text>
        <text x={boxXs[0]+10} y={boxY+62} fontSize="9" fill="#333">(6 consecutive dominant bits)</text>

        {/* Error Passive box */}
        <rect x={boxXs[1]} y={boxY} width={boxW} height={boxH} rx={5} fill="#fffbe6" stroke="#e07b00" strokeWidth="1.5"/>
        <text x={boxXs[1]+10} y={boxY+18} fontSize="10" fontWeight="700" fill="#e07b00">Error Passive:</text>
        <text x={boxXs[1]+10} y={boxY+34} fontSize="9" fill="#333">Can transmit &amp; receive</text>
        <text x={boxXs[1]+10} y={boxY+48} fontSize="9" fill="#333">Sends passive error flags</text>
        <text x={boxXs[1]+10} y={boxY+62} fontSize="9" fill="#333">(6 consecutive recessive bits)</text>

        {/* Bus Off box */}
        <rect x={boxXs[2]} y={boxY} width={boxW} height={boxH} rx={5} fill="#fff0e6" stroke="#a03000" strokeWidth="1.5"/>
        <text x={boxXs[2]+10} y={boxY+18} fontSize="10" fontWeight="700" fill="#a03000">Bus Off:</text>
        <text x={boxXs[2]+10} y={boxY+34} fontSize="9" fill="#333">Cannot transmit at all</text>
        <text x={boxXs[2]+10} y={boxY+48} fontSize="9" fill="#333">Does not disturb the bus</text>
        <text x={boxXs[2]+10} y={boxY+62} fontSize="9" fill="#333">Requires explicit recovery sequence</text>
      </svg>
      <div style={S.dCaption}>Error confinement protects the network: a consistently faulty node is automatically silenced without human intervention</div>
    </div>
  );
}

// ── Diagram: CAN vs Other Protocols ──────────────────────────────────
function DiagramProtocolCompare() {
  const W = 900, H = 300;
  const labelW = 140;
  const colW = 186;
  const gap = 4;
  const protocols = [
    { name:'CAN',    color:'#d4a000' },
    { name:'CAN FD', color:'#e07b00' },
    { name:'RS-485', color:'#b88000' },
    { name:'LIN',    color:'#8a7000' },
  ];
  const rows = [
    ['Wires',       ['2 (diff)',    '2 (diff)',    '2 (diff)',    '1 (single)']],
    ['Max Speed',   ['1 Mbit/s',   '8+ Mbit/s',  '10 Mbit/s',  '20 kbit/s']],
    ['Max Nodes',   ['~110 nodes', '~110 nodes', '32 nodes',   '16 slaves']],
    ['Arbitration', ['Non-destr.', 'Non-destr.', 'None (RS)',   'Master-slave']],
    ['Error Detect',['CRC+ACK+5', 'CRC+ACK+7', 'None built-in','Checksum']],
    ['Typical Use', ['Automotive', 'Automotive', 'Industrial',  'Low-cost auto']],
  ];
  const rowH = 38, startY = 56;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>CAN vs Related Protocols</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          {protocols.map((p,i)=>(
            <linearGradient key={i} id={`pcg${i}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={p.color}/>
              <stop offset="100%" stopColor={p.color} stopOpacity="0.78"/>
            </linearGradient>
          ))}
        </defs>

        {/* Label column bg */}
        <rect x={0} y={startY} width={labelW} height={rows.length*rowH} rx={4} fill="#fffbe6"/>

        {/* Column headers */}
        {protocols.map((p,i)=>{
          const colX = labelW + gap + i*(colW+gap);
          return (
            <g key={i}>
              <rect x={colX} y={8} width={colW} height={40} rx={6} fill={`url(#pcg${i})`}/>
              <text x={colX+colW/2} y={33} textAnchor="middle" fontSize="15" fontWeight="700" fill="#fff"
                fontFamily="'Georgia',serif">{p.name}</text>
            </g>
          );
        })}

        {/* Row labels */}
        {rows.map(([label],ri)=>(
          <g key={ri}>
            <rect x={0} y={startY+ri*rowH} width={labelW} height={rowH-2} rx={3}
              fill={ri%2===0?'#fffbe6':'#fff4cc'}/>
            <text x={8} y={startY+ri*rowH+rowH/2+5} fontSize="11" fontWeight="700"
              fill="#7a4f00" fontFamily="'Georgia',serif">{label}</text>
          </g>
        ))}

        {/* Data cells */}
        {protocols.map((p,pi)=>{
          const colX = labelW+gap+pi*(colW+gap);
          return rows.map(([,vals],ri)=>(
            <g key={`${pi}-${ri}`}>
              <rect x={colX} y={startY+ri*rowH} width={colW} height={rowH-2} rx={3}
                fill={ri%2===0?'#fffcf0':'#fffde8'} stroke="#e8c84a" strokeWidth="0.5"/>
              <text x={colX+colW/2} y={startY+ri*rowH+rowH/2+5} textAnchor="middle"
                fontSize="10" fill="#1a1200" fontFamily="'Courier New',monospace">{vals[pi]}</text>
            </g>
          ));
        })}

        <line x1={0} y1={startY+rows.length*rowH} x2={W} y2={startY+rows.length*rowH} stroke="#d4a000" strokeWidth="1.5"/>
      </svg>
      <div style={S.dCaption}>CAN's non-destructive arbitration and built-in error confinement make it uniquely suited for safety-critical networks</div>
    </div>
  );
}

// ── Main Export ───────────────────────────────────────────────────────
export default function CANBus() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Controller Area Network (CAN Bus) — Complete Reference</h1>
      <p style={S.p}>
        The Controller Area Network (CAN) protocol was developed by Robert Bosch GmbH in 1983 and standardised as
        ISO 11898. It was designed specifically for automotive and industrial environments where many microcontrollers
        and devices need to communicate with each other without a host computer — reliably, even in the presence of
        electrical noise, and with guaranteed fault isolation. Today it is found in virtually every modern vehicle,
        industrial robot, medical device, and aerospace system.
      </p>

      <InfoBox title="CAN at a Glance" items={[
        "Physical layer: 2-wire differential bus (CAN_H, CAN_L) — highly noise-immune",
        "Topology: Linear bus, multi-master — any node can transmit at any time",
        "Speed: Up to 1 Mbit/s (Classical CAN); up to 8+ Mbit/s (CAN FD data phase)",
        "Nodes: Up to ~110 nodes on one bus (limited by bus load and transceiver specs)",
        "Arbitration: Non-destructive, priority-based — lower ID number = higher priority",
        "Error detection: CRC, ACK, bit monitoring, frame check, stuff check — 5 mechanisms",
        "Error confinement: Faulty nodes automatically enter Bus Off state and stop transmitting",
        "Standard: ISO 11898-1 (data link), ISO 11898-2 (physical layer / High-Speed CAN)",
      ]}/>

      <h2 style={S.h2}>Network Topology & Physical Layer</h2>
      <p style={S.p}>
        CAN uses a <strong>linear bus topology</strong> — all nodes connect to a single pair of wires. The bus is
        terminated at both ends with 120 Ω resistors to match the characteristic impedance of the cable and prevent
        signal reflections. Unlike SPI or I²C, there is no master: any node can initiate a transmission at any time.
      </p>
      <DiagramCANTopology/>

      <Table2 rows={[
        ["CAN_H / CAN_L","Two wires forming a twisted differential pair\nTypical cable: 120Ω characteristic impedance, twist pitch ~25mm"],
        ["Termination","120Ω at each end (or split termination: 2×60Ω + 100nF capacitor to GND for EMI)\nMissing termination → signal ringing and communication errors"],
        ["Differential voltage","Dominant (logic 0): CAN_H=3.5V, CAN_L=1.5V → V_diff=2V\nRecessive (logic 1): both lines at 2.5V → V_diff≈0V"],
        ["Noise immunity","Common-mode noise on both wires cancels in the differential receiver\nImmune to ground potential differences between nodes up to ±2V"],
        ["ISO 11898-2 (HS-CAN)","High-Speed CAN: up to 1 Mbit/s, bus length up to ~40m at 1 Mbit/s\nBus length vs speed: 500m at 125 kbit/s, 1000m at 50 kbit/s"],
        ["ISO 11898-3 (LS-CAN)","Low-Speed / Fault-Tolerant CAN: up to 125 kbit/s\nCan operate with one wire broken — used in body control networks"],
        ["Transceiver ICs","Convert TTL/CMOS logic from MCU ↔ differential CAN bus signals\nExamples: TJA1050, MCP2551, SN65HVD230, TJA1462 (FD capable)"],
        ["Stub length","Short stubs from backbone to node: keep < 0.3m at 1 Mbit/s to avoid reflections\nLonger stubs require lower bit rates"],
        ["Galvanic isolation","Optional: ISO7741 or ADuM1201 digital isolators + isolated DC-DC converter\nRequired when nodes span different power domains or high-voltage systems"],
      ]}/>

      <h2 style={S.h2}>Differential Signalling</h2>
      <p style={S.p}>
        CAN's noise immunity comes entirely from differential signalling. The receiver measures only the
        <em> difference</em> between CAN_H and CAN_L. Any interference that appears equally on both wires
        (common-mode noise) is automatically cancelled. The "wired-AND" property of the bus means that a single
        dominant bit from any node can override a recessive bit from all others.
      </p>
      <DiagramDifferential/>

      <h2 style={S.h2}>CAN Frame Structure — Standard (11-bit ID)</h2>
      <p style={S.p}>
        All communication happens in <strong>frames</strong>. The most common is the Data Frame, which carries
        a payload of 0–8 bytes wrapped in a structured envelope of control, CRC, and acknowledgement fields.
        The 11-bit identifier encodes both the message type and its priority.
      </p>
      <DiagramCANFrame/>
      <Table2 rows={[
        ["SOF (Start of Frame)","1 dominant bit — synchronises all receivers on the bus\nAll nodes use this edge to reset their bit timing counters"],
        ["Identifier (11-bit)","Encodes message type AND priority\nLower numeric value = higher priority (dominant bits win in arbitration)\nExample: 0x000 highest priority, 0x7FF lowest"],
        ["RTR (Remote Tx Request)","0=Data frame (contains payload)\n1=Remote frame (requests data from another node with same ID — rarely used)"],
        ["IDE (ID Extension bit)","0=Standard frame (11-bit ID)\n1=Extended frame (29-bit ID, CAN 2.0B)"],
        ["DLC (Data Length Code)","4-bit field: values 0–8 indicate byte count of payload\nValues 9–15 are valid but reserved in classical CAN (used differently in CAN FD)"],
        ["Data Field","0 to 8 bytes of payload (MSB first)\nContent and interpretation defined entirely by the application / protocol layer"],
        ["CRC (Cyclic Redundancy Check)","15-bit CRC computed over all bits from SOF to end of data\nGenerator polynomial: x¹⁵ + x¹⁴ + x¹⁰ + x⁸ + x⁷ + x⁴ + x³ + x + 1\nFollowed by 1 recessive CRC delimiter bit"],
        ["ACK Slot","Transmitter sends recessive; any correctly receiving node pulls it dominant\nIf no ACK received → transmitter detects error and retransmits"],
        ["EOF (End of Frame)","7 recessive bits — no bit stuffing applied here\nMarks boundary; nodes can prepare for next frame"],
        ["IFS (Interframe Space)","3 recessive bits minimum between consecutive frames\nAllows nodes time to process received frame before next SOF"],
        ["Bit stuffing","After 5 consecutive bits of the same polarity, sender inserts opposite polarity bit\nReceiver removes stuffed bit; violation of stuffing rule is a bus error"],
      ]}/>

      <h2 style={S.h2}>Extended Frame (29-bit ID)</h2>
      <p style={S.p}>
        CAN 2.0B extended frames use a 29-bit identifier, giving over 536 million unique message IDs. The IDE bit
        set to 1 signals an extended frame. Standard and extended frames can coexist on the same bus — a standard
        frame with a matching 11-bit prefix will always win arbitration over an extended frame with the same prefix
        because IDE=0 (dominant) beats IDE=1 (recessive).
      </p>
      <DiagramExtendedFrame/>

      <h2 style={S.h2}>Bus Arbitration</h2>
      <p style={S.p}>
        CAN's most remarkable property is <strong>non-destructive arbitration</strong>. When two nodes start
        transmitting simultaneously, they both continue bit-by-bit. Each transmitter monitors the bus while it
        transmits. When a node transmits a recessive bit (1) but reads back a dominant bit (0), it knows it has
        lost arbitration — it immediately stops transmitting and becomes a receiver. The winning message is never
        corrupted and requires no retransmission.
      </p>
      <DiagramArbitration/>
      <Table2 rows={[
        ["Wired-AND principle","Dominant (0) always wins over recessive (1) on the shared bus\nAny node can pull CAN_H↑ and CAN_L↓ simultaneously → dominant state"],
        ["Priority rule","Lower ID number → higher priority (more leading zeros = more dominant bits)\nID 0x001 always wins over 0x002; 0x000 is highest possible priority"],
        ["Simultaneous transmission","Both nodes start at exactly the same SOF moment — common in practice\nArbitration resolves without any delay or message corruption"],
        ["Real-time guarantee","Highest priority message is guaranteed to be sent within one frame period\nUsed for safety-critical messages: airbag trigger, ABS intervention"],
        ["Message scheduling","Assign IDs based on required latency: lowest ID for fastest required response\nMany systems reserve 0x000–0x0FF for critical, 0x700+ for diagnostics"],
        ["Starvation risk","A constant stream of high-priority messages can starve lower-priority nodes\nMitigated by proper ID assignment and maximum bus load design (<80%)"],
      ]}/>

      <h2 style={S.h2}>Bit Timing & Baud Rate Configuration</h2>
      <p style={S.p}>
        Because CAN is synchronous (clock edge on each bit) but the clock is embedded in the data stream
        (via bit stuffing and resynchronisation), each node independently generates its bit clock from a local
        oscillator. Bit timing registers in the CAN controller define exactly how many Time Quanta (TQ) make up
        one bit period and where the sample point falls.
      </p>
      <DiagramBitTiming/>
      <Table2 rows={[
        ["Time Quantum (TQ)","Smallest time unit in CAN bit timing\nTQ = Prescaler / f_oscillator  (e.g. 48MHz / 6 = 8MHz → TQ = 125ns)"],
        ["Sync Segment","Always 1 TQ — node expects an edge here for synchronisation\nAll nodes align to the SOF falling edge"],
        ["Propagation Segment","Compensates for signal propagation delay on the bus + transceiver delays\nRule: Prop_Seg ≥ 2 × (bus_propagation_delay + transceiver_delay)"],
        ["Phase Segment 1 & 2","Phase Seg 1 can be lengthened; Phase Seg 2 can be shortened during resync\nSample point falls at end of Phase Seg 1 (beginning of Phase Seg 2)"],
        ["Sample point","Typical position: 75–80% of bit period\nAutomotive standard CIA 601 recommends 87.5% at low speeds"],
        ["SJW (Sync Jump Width)","Maximum TQ adjustment per resynchronisation (1–4 TQ)\nLarger SJW = more tolerant of oscillator drift; narrower timing margin"],
        ["Oscillator tolerance","CAN allows up to ±1.58% oscillator tolerance (much more relaxed than UART)\nPractical recommendation: ±0.5% crystal for reliable high-speed operation"],
        ["Common baud rates","10k, 20k, 50k, 100k, 125k, 250k, 500k, 800k, 1000k bps\nAutomotive: 500 kbps (powertrain), 125 kbps (body); industry: 250 kbps typical"],
      ]}/>

      <h2 style={S.h2}>Error Detection & Handling</h2>
      <p style={S.p}>
        CAN has five independent error detection mechanisms — more than almost any other serial bus. These operate
        simultaneously and automatically. When an error is detected, an Error Frame is transmitted to inform all
        nodes, the erroneous frame is discarded, and the transmitter retransmits.
      </p>
      <DiagramErrorFrame/>
      <Table2 rows={[
        ["1. CRC Error","Receiver recomputes 15-bit CRC and compares to received CRC field\nDetects all single-bit errors, all odd-bit errors, all burst errors ≤ 15 bits"],
        ["2. ACK Error","Transmitter checks ACK slot: if recessive (no ACK), triggers error\nCaught immediately if no node received the frame correctly"],
        ["3. Bit Monitoring","Transmitter reads back every bit it sends; compares to what it transmitted\nDetects transceiver failures, stuck bus, and dominant → recessive violations"],
        ["4. Bit Stuffing Error","After 5 identical bits, a stuff bit of opposite polarity must appear\n6 identical bits in a row = stuffing violation → error flag generated"],
        ["5. Form Error","Fixed-format fields (CRC delimiter, ACK delimiter, EOF) checked for valid values\nDetects corrupted frame boundaries"],
        ["Undetected error rate","CAN detects >99.9999998% of all errors\nResidual error probability: < 4.7×10⁻¹¹ per message at 1 Mbit/s with 8-byte payload"],
        ["Error frame","6 dominant bits (active) or 6 recessive bits (passive) + 8-bit error delimiter\nDestroy current frame; all nodes discard it and await retransmission"],
        ["TEC (Transmit Error Counter)","Incremented on transmit error (+8), decremented on successful frame (−1)\nThreshold at 127 (→ Error Passive) and 255 (→ Bus Off)"],
        ["REC (Receive Error Counter)","Incremented on receive error (+1), decremented on success (−1)\nThreshold at 127 (→ Error Passive); receiver never reaches Bus Off"],
      ]}/>

      <h2 style={S.h2}>Error State Machine</h2>
      <DiagramErrorStates/>

      <h2 style={S.h2}>CAN FD — Flexible Data-Rate</h2>
      <p style={S.p}>
        CAN FD, standardised in ISO 11898-1:2015, addresses the two main limitations of classical CAN: it increases
        the maximum payload from 8 to 64 bytes per frame, and it increases the data-phase bit rate to 8 Mbit/s or
        more — while keeping full backwards compatibility during the arbitration phase.
      </p>
      <DiagramCANFD/>
      <Table2 rows={[
        ["FDF bit (FD Frame)","Formerly reserved r0 bit; FDF=1 signals a CAN FD frame\nAll FD-capable nodes handle it; classical nodes see a form error and stay quiet"],
        ["BRS bit (Bit Rate Switch)","BRS=1: data phase (DLC through CRC) transmitted at faster bit rate\nBRS=0: entire frame at nominal rate (valid CAN FD frame but no speed boost)"],
        ["ESI bit (Error State Indicator)","ESI=0: transmitting node is Error Active\nESI=1: transmitting node is Error Passive — receiver can flag suspicious data"],
        ["Payload sizes (DLC)","DLC 0–8 bytes same as before; DLC 9–15 map to 12, 16, 20, 24, 32, 48, 64 bytes\nAllows much more data per frame: sensor arrays, firmware updates, video metadata"],
        ["Enhanced CRC","12-byte payload: 17-bit CRC; 64-byte payload: 21-bit CRC (better error detection)\nStronger polynomial than classical 15-bit CRC to match larger payload"],
        ["Bit rate switching point","Switch to fast rate after BRS bit; switch back after CRC delimiter\nAll nodes must know both nominal and data bit rates in advance"],
        ["Typical data bit rates","2 Mbit/s common in automotive (AUTOSAR);  5–8 Mbit/s in lab and industrial\nLimited by bus length: 2 Mbit/s ≈ 40m max; 5 Mbit/s ≈ 15m max"],
        ["CAN XL","Next generation (CiA 610-1): up to 20 Mbit/s, 2048-byte payload\nIncludes VCAN (Virtual CAN) for Ethernet tunnelling — not yet widely deployed"],
        ["Transceiver requirement","All nodes on bus must use FD-capable transceivers (e.g. TJA1462, TCAN1044)\nMixing classical and FD transceivers on same bus causes errors"],
      ]}/>

      <h2 style={S.h2}>Higher-Layer Protocols</h2>
      <p style={S.p}>
        CAN defines only the physical and data-link layers (OSI layers 1 & 2). The raw CAN frame has no concept of
        larger messages, sessions, or services. Higher-layer protocols built on top of CAN provide these features
        for specific industries.
      </p>
      <Table2 rows={[
        ["CANopen (CiA 301)","Device profile standard for industrial automation\nDefines Object Dictionary, PDO (process data), SDO (configuration), NMT (network management)\nUsed in: robotics, CNC machines, medical devices, building automation"],
        ["SAE J1939","Heavy-duty vehicle standard (trucks, buses, agriculture)\nUses 29-bit IDs with structured PGN (Parameter Group Number)\nDefines parameter encoding: speed, RPM, fuel, braking, axle weights"],
        ["CANaerospace","Aviation standard — deterministic scheduling, redundant buses\nUsed in: Airbus, Boeing, helicopters, UAVs"],
        ["DeviceNet","Industrial automation (Allen-Bradley / Rockwell)\nBased on CAN; adds application layer for PLCs, sensors, actuators"],
        ["NMEA 2000","Marine electronics standard (GPS, depth, wind, engine data)\nBased on J1939; plug-and-play connectors and certified devices"],
        ["ISO 15765 (UDS over CAN)","Unified Diagnostic Services — used by OBD-II scan tools\nMulti-frame transport (ISO-TP) for messages > 8 bytes\nServices: read DTCs, live data, flash ECU firmware, security access"],
        ["ISO-TP (ISO 15765-2)","Transport layer enabling messages up to 4095 bytes over 8-byte CAN frames\nSingle Frame (SF), First Frame (FF), Consecutive Frame (CF), Flow Control (FC)\nUsed for all automotive diagnostics and firmware over CAN"],
        ["AUTOSAR COM","Automotive software standard COM layer abstracts CAN/LIN/FlexRay/Ethernet\nSignal packing, PDU routing, bus scheduling defined in XML (ARXML)"],
      ]}/>

      <h2 style={S.h2}>Comparing CAN to Related Protocols</h2>
      <DiagramProtocolCompare/>

      <h2 style={S.h2}>CAN Controller & Transceiver Architecture</h2>
      <Table2 rows={[
        ["CAN controller","Implements the full CAN protocol in hardware (bit timing, framing, CRC, arbitration)\nEmbedded in most MCUs: STM32 (bxCAN/FDCAN), ESP32 (TWAI), PIC32, RP2040 (via PIO)\nStandalone controllers: MCP2515 (SPI interface), SJA1000"],
        ["CAN transceiver","Converts TTL logic from controller ↔ differential bus voltage\nIsolated transceivers (ISO7421 + DC-DC) for galvanic isolation\nCommon ICs: TJA1050 (classical), TJA1462/TCAN1044 (FD-capable)"],
        ["Acceptance filtering","Hardware filter in controller: masks/IDs compared to received message ID\nOnly matching messages trigger interrupt — reduces CPU load dramatically\nConfigured via mask and code registers (SJA1000) or FIFO filters (STM32 FDCAN)"],
        ["Tx/Rx FIFOs","Hardware FIFOs buffer messages; controller handles timing autonomously\nMCP2515: 3 Tx buffers with priority, 2 Rx buffers + acceptance filters\nSTM32 FDCAN: 3 Tx buffers, configurable Rx FIFOs up to 64 elements"],
        ["Listen-Only mode","Controller receives all frames but does not transmit (no ACK, no error frames)\nUsed for bus monitoring, logging, baud rate detection without disturbing bus"],
        ["Loopback mode","Tx output internally connected to Rx input; no bus activity\nUsed during software development to test message encoding/decoding"],
        ["Wake-up filter","Transceiver can wake a sleeping MCU on bus activity (selective wake)\nISO 11898-6: standardised partial networking — only specific IDs wake node\nCritical for automotive battery drain: ECUs sleep when vehicle is off"],
        ["Bus load","Recommended maximum: 30–50% for reliable real-time behaviour\nAt 80%+ load: arbitration latency increases, error recovery becomes unreliable\nCalculate: (frame_bits × messages_per_second) / bit_rate"],
      ]}/>

      <h2 style={S.h2}>Automotive CAN Networks</h2>
      <Table2 rows={[
        ["Modern vehicle bus count","Typical modern car: 5–15 separate CAN buses, 70–150 ECUs\nSeparated by speed and function; connected by a central gateway ECU"],
        ["Powertrain CAN (500 kbps)","Engine ECU, transmission, ABS, ESP, hybrid battery management\nHighest priority, most time-critical — millisecond response required"],
        ["Body CAN (125 kbps)","Door modules, windows, mirrors, lighting, climate control\nLow speed acceptable — comfort systems not safety-critical"],
        ["Infotainment CAN","Instrument cluster, head unit, navigation, phone integration\nOften also has MOST or Automotive Ethernet for high-bandwidth video"],
        ["ADAS CAN / CAN FD","Radar, lidar, camera ECUs, parking sensors, lane assist\nFD required for higher sensor data bandwidth; connected to central domain controller"],
        ["Gateway ECU","Bridges multiple CAN buses; routes messages between domains\nEnforces security: filters/transforms messages between powertrain and OBD port"],
        ["OBD-II port (SAE J1962)","16-pin diagnostic connector; exposes CAN bus at pins 6 (CAN_H) & 14 (CAN_L)\nUsed by: scan tools, performance monitors, fleet telematics, insurance dongles"],
        ["Cybersecurity","CAN has no built-in authentication — any node can send any ID\nAttacks: replay, fuzzing, ID spoofing. Mitigations: gateway firewalls, SecOC (MAC)\nISO/SAE 21434: automotive cybersecurity engineering lifecycle standard"],
      ]}/>

      <h2 style={S.h2}>CAN Bus Debugging & Tools</h2>
      <Table2 rows={[
        ["Oscilloscope / logic analyser","Measure actual CAN_H and CAN_L waveforms; verify differential voltage levels\nDifferential probe required for true V_diff measurement; ≥20 MHz bandwidth for 1 Mbit/s"],
        ["CAN analyser / USB dongle","PEAK PCAN-USB, Kvaser, IXXAT, Vector VN-series — hardware interface to PC\nOpen-source: canable (USB-CAN adapter), CANable, Canarino"],
        ["SocketCAN (Linux)","CAN interface via standard network socket API\nTools: ip link, candump, cansend, cangen, cansniffer, canplayer"],
        ["candump example","candump can0  → prints all received frames\ncandump -l can0  → logs to file (for replay with canplayer)"],
        ["cansend example","cansend can0 123#DEADBEEF  → sends ID 0x123 with 4-byte payload\ncansend can0 1F334455#R  → sends remote frame"],
        ["Wireshark","Supports SocketCAN via socketcan-plugin; decodes J1939 and CANopen\nReal-time capture + filtering by ID, PGN, error frames"],
        ["CANdb++ / DBC files","Vector DBC format: maps raw CAN IDs and byte fields to named signals\nSignal { start_bit, length, scale, offset, min, max, unit }\nUsed by CANalyzer, Python-can, SavvyCAN, BUSMASTER"],
        ["Python-can library","pip install python-can — supports PCAN, SocketCAN, virtual bus\nimport can; bus=can.Bus('can0',bustype='socketcan'); bus.recv()"],
        ["Common faults","Missing termination → waveform ringing; wrong bit rate → framing errors\nOpen wire → asymmetric waveform; ECU shorted bus → stuck dominant"],
      ]}/>

      <InfoBox title="Key Formulae & Constants" items={[
        "Bit period: T_bit = 1 / baud_rate  (e.g. 500 kbps → T_bit = 2 µs)",
        "Time Quantum: TQ = Prescaler / f_clk  (e.g. 48 MHz / 6 → TQ = 125 ns)",
        "Bit timing: N_TQ = Sync(1) + Prop + PhSeg1 + PhSeg2  (total must equal T_bit / TQ)",
        "Sample point %: (Sync + Prop + PhSeg1) / N_TQ × 100%",
        "Max bus length (HS-CAN): L_max ≈ 50m × (1 Mbit/s / baud_rate) — simplified rule",
        "Bus load: utilisation = Σ(frame_bits × msg_rate) / baud_rate × 100%",
        "CRC polynomial (15-bit): x¹⁵ + x¹⁴ + x¹⁰ + x⁸ + x⁷ + x⁴ + x³ + x + 1",
        "Standard frame bits: 44 + 8×N_bytes + stuffing bits (up to floor((34+8×N)/4) stuff bits)",
        "TEC: +8 on transmit error, −1 on successful frame; Bus Off at TEC > 255",
        "REC: +1 on receive error (if REC < 128), −1 on successful frame; never causes Bus Off",
      ]}/>
    </div>
  );
}